module.exports = __webpack_public_path__ + "img/sjwk.528c3a82.svg";